module.exports = function(bh) {
    bh.match('page-up', function(ctx, json) {
        ctx
            .cls('fade')
            .content([
                {mix: {block: 'container'}, content: [
                    {block: 'fi', mods: {icon: 'angle-up'}},
                ]},
            ]);
    });
};
